export default __webpack_public_path__ + "static/media/bulb.8811a1aa.svg";